/* ==========================================================================
   EDME Collection — MUQ Edition v1.4
   CSS ana çözümü uygular; JS tema içi inline stilleri de güvenli biçimde ezer.
   ========================================================================== */
(function() {
  'use strict';

  function initCollection(root) {
    if (!root || root.__edmeInit) return;
    root.__edmeInit = true;

    var body = root.querySelector('[data-col-body]');
    var grid = root.querySelector('[data-product-grid]');
    var toggleBtn = root.querySelector('[data-filter-toggle]');
    var overlay = root.querySelector('[data-filter-overlay]');
    var defaultOpen = root.getAttribute('data-filter-default-open') === 'true';

    root.classList.add('is-ready');

    var gridSwapTimer = null;

    function setFilterState(open, skipAnimation) {
      if (!body) return;

      if (open) {
        body.classList.add('is-filter-open');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');

        if (window.innerWidth <= 990 && overlay) {
          overlay.hidden = false;
          requestAnimationFrame(function() { overlay.classList.add('is-visible'); });
          document.body.style.overflow = 'hidden';
        } else {
          if (gridSwapTimer) clearTimeout(gridSwapTimer);
          if (skipAnimation) {
            if (grid) grid.classList.add('is-cols-filtered');
          } else {
            gridSwapTimer = setTimeout(function() {
              if (grid) grid.classList.add('is-cols-filtered');
            }, 180);
          }
        }
      } else {
        body.classList.remove('is-filter-open');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');

        if (overlay) {
          overlay.classList.remove('is-visible');
          setTimeout(function() { overlay.hidden = true; }, 300);
          document.body.style.overflow = '';
        }

        if (window.innerWidth > 990) {
          if (gridSwapTimer) clearTimeout(gridSwapTimer);
          if (grid) grid.classList.remove('is-cols-filtered');
        } else {
          if (grid) grid.classList.remove('is-cols-filtered');
        }
      }
    }

    var initialOpen = defaultOpen;
    if (window.innerWidth <= 990) initialOpen = false;
    setFilterState(initialOpen, true);

    if (toggleBtn && !toggleBtn.disabled) {
      toggleBtn.addEventListener('click', function() {
        var isOpen = body.classList.contains('is-filter-open');
        setFilterState(!isOpen, false);
      });
    }
    if (overlay) overlay.addEventListener('click', function() { setFilterState(false, false); });

    var closeBtn = root.querySelector('[data-filter-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setFilterState(false, false);
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && body.classList.contains('is-filter-open')) {
        setFilterState(false, false);
      }
    });

    var lastIsMobile = window.innerWidth <= 990;
    window.addEventListener('resize', function() {
      var nowIsMobile = window.innerWidth <= 990;
      if (nowIsMobile !== lastIsMobile) {
        lastIsMobile = nowIsMobile;
        if (nowIsMobile) {
          document.body.style.overflow = '';
          if (body.classList.contains('is-filter-open')) setFilterState(false, true);
        }
      }
    });

    var sortWrap = root.querySelector('[data-sort-wrapper]');
    var sortBtn = root.querySelector('[data-sort-btn]');
    var sortMenu = root.querySelector('[data-sort-menu]');
    if (sortBtn && sortMenu) {
      sortBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = !sortMenu.hidden;
        sortMenu.hidden = isOpen;
        sortBtn.setAttribute('aria-expanded', String(!isOpen));
        if (sortWrap) sortWrap.setAttribute('data-open', String(!isOpen));
      });
      document.addEventListener('click', function(e) {
        if (sortWrap && !sortWrap.contains(e.target)) {
          sortMenu.hidden = true;
          sortBtn.setAttribute('aria-expanded', 'false');
          sortWrap.setAttribute('data-open', 'false');
        }
      });
      sortMenu.querySelectorAll('[data-sort-value]').forEach(function(li) {
        li.addEventListener('click', function() {
          var val = li.getAttribute('data-sort-value');
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', val);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
    }

    var filterForm = root.querySelector('[data-filter-form]');
    if (filterForm) {
      var debounceTimer;
      filterForm.addEventListener('change', function(e) {
        if (e.target.matches('input[type="checkbox"]')) submitFilterForm();
      });
      filterForm.addEventListener('input', function(e) {
        if (e.target.matches('input[type="number"]')) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(submitFilterForm, 650);
        }
      });
      function submitFilterForm() {
        var formData = new FormData(filterForm);
        var params = new URLSearchParams();
        formData.forEach(function(value, key) {
          if (value !== '' && value !== null) params.append(key, value);
        });
        var currentUrl = new URL(window.location.href);
        var sortBy = currentUrl.searchParams.get('sort_by');
        if (sortBy) params.set('sort_by', sortBy);
        var newUrl = window.location.pathname + '?' + params.toString();
        window.location.href = newUrl;
      }
    }

    root.querySelectorAll('.edme-pcard').forEach(function(card) { initProductCard(card); });

  }

  function forceProductImageCover(card) {
    if (!card) return;

    var root = card.closest('[data-edme-collection]');
    var ratio = root ? (root.getAttribute('data-card-aspect-ratio') || '2/3') : '2/3';
    var ratioCss = ratio.replace('/', ' / ');
    var media = card.querySelector('.edme-pcard__media, [data-pcard-media]');
    if (!media) return;

    function important(el, property, value) {
      if (el) el.style.setProperty(property, value, 'important');
    }

    important(media, 'position', 'relative');
    important(media, 'display', 'block');
    important(media, 'width', '100%');
    important(media, 'height', 'auto');
    important(media, 'min-height', '0');
    important(media, 'aspect-ratio', ratioCss);
    important(media, 'padding', '0');
    important(media, 'margin', '0');
    important(media, 'overflow', 'hidden');

    media.querySelectorAll(
      ':scope > a, :scope > picture, .edme-pcard__link, [data-pcard-link], .edme-pcard__track, [data-pcard-track]'
    ).forEach(function(el) {
      important(el, 'position', 'absolute');
      important(el, 'inset', '0');
      important(el, 'width', '100%');
      important(el, 'height', '100%');
      important(el, 'min-height', '0');
      important(el, 'padding', '0');
      important(el, 'margin', '0');
    });

    media.querySelectorAll('.edme-pcard__track, [data-pcard-track]').forEach(function(track) {
      important(track, 'display', 'flex');
      important(track, 'align-items', 'stretch');
    });

    media.querySelectorAll('.edme-pcard__slide, [data-pcard-slide]').forEach(function(slide) {
      important(slide, 'position', 'relative');
      important(slide, 'display', 'block');
      important(slide, 'flex', '0 0 100%');
      important(slide, 'width', '100%');
      important(slide, 'height', '100%');
      important(slide, 'min-height', '0');
      important(slide, 'padding', '0');
      important(slide, 'margin', '0');
      important(slide, 'overflow', 'hidden');
    });

    media.querySelectorAll('picture').forEach(function(picture) {
      important(picture, 'position', 'absolute');
      important(picture, 'inset', '0');
      important(picture, 'display', 'block');
      important(picture, 'width', '100%');
      important(picture, 'height', '100%');
      important(picture, 'padding', '0');
      important(picture, 'margin', '0');
      important(picture, 'overflow', 'hidden');
    });

    media.querySelectorAll('img').forEach(function(img) {
      important(img, 'position', 'absolute');
      important(img, 'inset', '0');
      important(img, 'display', 'block');
      important(img, 'width', '100%');
      important(img, 'height', '100%');
      important(img, 'min-width', '100%');
      important(img, 'min-height', '100%');
      important(img, 'max-width', 'none');
      important(img, 'max-height', 'none');
      important(img, 'padding', '0');
      important(img, 'margin', '0');
      important(img, 'object-fit', 'cover');
      important(img, 'object-position', '50% 50%');
      important(img, 'transform', 'none');
    });
  }

  function initProductCard(card) {
    if (card.__edmeInit) return;
    card.__edmeInit = true;

    forceProductImageCover(card);

    var primaryImg = card.querySelector('[data-pcard-primary]');
    var colorNameEl = card.querySelector('[data-pcard-color-label]');
    var sizesContainer = card.querySelector('[data-pcard-sizes]');
    var fallbackUrl = card.getAttribute('data-product-url');

    var swatches = card.querySelectorAll('.edme-pcard__swatch');

    swatches.forEach(function(sw) {
      sw.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        swatches.forEach(function(s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');

        var newImg = sw.getAttribute('data-swatch-image');
        var colorName = sw.getAttribute('data-color-value') || '';

        if (newImg && primaryImg) {
          primaryImg.src = newImg;
          primaryImg.removeAttribute('srcset');
          requestAnimationFrame(function() { forceProductImageCover(card); });
        }
        if (colorNameEl && colorName) {
          colorNameEl.textContent = colorName.toLowerCase();
        }

        // Carousel mode → ilk slide'a dön
        if (card.hasAttribute('data-pcard-carousel')) {
          var track = card.querySelector('[data-pcard-track]');
          var slides = card.querySelectorAll('.edme-pcard__slide');
          var dots = card.querySelectorAll('[data-dot-index]');
          if (track) track.style.transform = 'translateX(0%)';
          slides.forEach(function(s, i) { s.classList.toggle('is-active', i === 0); });
          dots.forEach(function(d, i) { d.classList.toggle('is-active', i === 0); });
        }
      });
    });

    if (sizesContainer) {
      sizesContainer.querySelectorAll('.edme-pcard__size').forEach(function(sz) {
        sz.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (sz.disabled) return;
          var variantId = sz.getAttribute('data-variant-id');
          if (variantId && fallbackUrl) {
            var sep = fallbackUrl.indexOf('?') > -1 ? '&' : '?';
            window.location.href = fallbackUrl + sep + 'variant=' + variantId;
          }
        });
      });
    }

    card.querySelectorAll('img').forEach(function(img) {
      img.addEventListener('dragstart', function(e) { e.preventDefault(); });
      img.addEventListener('load', function() { forceProductImageCover(card); });
    });

    // === CAROUSEL LOGIC ===
    if (card.hasAttribute('data-pcard-carousel')) {
      initCarousel(card);
    }
  }

  function initCarousel(card) {
    var media = card.querySelector('.edme-pcard__media');
    var track = card.querySelector('[data-pcard-track]');
    if (!media || !track) return;

    var slides = track.querySelectorAll('.edme-pcard__slide');
    var slideCount = slides.length;
    if (slideCount <= 1) return;

    var dots = card.querySelectorAll('[data-dot-index]');
    var prevBtn = card.querySelector('[data-pcard-prev]');
    var nextBtn = card.querySelector('[data-pcard-next]');
    var link = card.querySelector('[data-pcard-link]');

    var currentIndex = 0;
    var isDesktop = window.matchMedia('(hover: hover)').matches && window.innerWidth > 990;

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx >= slideCount) idx = slideCount - 1;
      currentIndex = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';

      slides.forEach(function(s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      updateArrows();
    }

    function updateArrows() {
      if (prevBtn) {
        prevBtn.setAttribute('aria-disabled', currentIndex === 0 ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.setAttribute('aria-disabled', currentIndex === slideCount - 1 ? 'true' : 'false');
      }
    }

    // Arrow clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex + 1);
      });
    }

    // Dot clicks
    dots.forEach(function(dot) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        goTo(idx);
      });
    });

    // === DESKTOP: Mouse zone hover devre dışı (sadece ok'lar kullanılacak) ===
    // (önceden mousemove ile slide değişiyordu, kullanıcı isteğiyle kaldırıldı)

    // === MOBILE: Touch swipe ===
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;
    var isSwiping = false;

    media.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      isSwiping = false;
    }, { passive: true });

    media.addEventListener('touchmove', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      var dx = Math.abs(touchEndX - touchStartX);
      var dy = Math.abs(touchEndY - touchStartY);
      // Yatay hareket daha baskın → swipe niyeti
      if (dx > dy && dx > 10) {
        isSwiping = true;
      }
    }, { passive: true });

    media.addEventListener('touchend', function(e) {
      if (!isSwiping) return;
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      var threshold = 40;

      if (diff > threshold) {
        // Sola swipe → sonraki
        goTo(currentIndex + 1);
      } else if (diff < -threshold) {
        // Sağa swipe → önceki
        goTo(currentIndex - 1);
      }
    }, { passive: true });

    // Swipe sırasında <a> tıklamasını engelle (sadece swipe gerçekleşmişse)
    if (link) {
      link.addEventListener('click', function(e) {
        if (isSwiping) {
          e.preventDefault();
          isSwiping = false;
        }
      });
    }

    // Initial state
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('[data-edme-collection]').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('[data-edme-collection]').forEach(function(el) {
        el.__edmeInit = false;
        initCollection(el);
      });
    }
  });
})();